/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Analysis_ReasoningInputs */

const en_ai_analysis_reasoning = /** @type {(inputs: Ai_Analysis_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Reasoning`)
};

const pt_br2_ai_analysis_reasoning = /** @type {(inputs: Ai_Analysis_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raciocínio da IA`)
};

/**
* | output |
* | --- |
* | "AI Reasoning" |
*
* @param {Ai_Analysis_ReasoningInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const ai_analysis_reasoning = /** @type {((inputs?: Ai_Analysis_ReasoningInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Analysis_ReasoningInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_analysis_reasoning(inputs)
	return pt_br2_ai_analysis_reasoning(inputs)
});